import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "dismissBtn"];
  static values = {
    dismissUrl: String,
  };

  connect() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = "hidden";
  }

  disconnect() {
    // Restore body scroll when modal is closed
    document.body.style.overflow = "";
  }

  async dismiss() {
    if (this.hasDismissBtnTarget) {
      this.dismissBtnTarget.disabled = true;
    }

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    if (!csrfToken) {
      console.error("CSRF token not found");
      this.close();
      return;
    }

    try {
      const response = await fetch(this.dismissUrlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        console.error("Failed to dismiss announcement:", response.status);
      }
    } catch (error) {
      console.error("Error dismissing announcement:", error);
    } finally {
      // Always close the modal
      this.close();
    }
  }

  close() {
    // Use CSS class for exit animation
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove("animate-popup-enter");
      this.modalTarget.classList.add("animate-popup-exit");
    }

    this.element.style.transition = "opacity 0.2s ease-in";
    this.element.style.opacity = "0";

    setTimeout(() => {
      this.element.remove();
      document.body.style.overflow = "";
    }, 200);
  }

  backdropClose(event) {
    if (event.target === this.element) {
      this.dismiss();
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
